






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'Bar'
})
export default class Bar extends Vue {
  @Prop() private msg!: string;
  @Prop() private bgColor!: string;
  @Prop() private color!: string;
}
